// extracted by mini-css-extract-plugin
export default {"container":"qCBZK","schemes":"CiSG0","placeholder":"chuQv","schemeCell":"tpZ2C","schemeImgWrapper":"v3jbI","schemeImg":"vVmKj","landscape":"UQpEP","portrait":"iLedo"};